import CustomModalHeader from 'components/Custom/CustomModalHeader'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { agreeToTerms } from 'store/Course/actions'

function CompletionTermsModal({ showModal, setShowModal, courseId }) {
  const dispatch = useDispatch()
  const agreementContent = useSelector(
    (state) => state.courseConfig.agreementContent
  )

  const handleAgree = () => {
    dispatch(agreeToTerms(courseId))
    setShowModal(false)
  }

  const handleCancel = () => {
    setShowModal(false)
  }

  return (
    <Modal
      isOpen={showModal}
      toggle={handleCancel}
      size='md'
      centered
      scrollable
    >
      <CustomModalHeader title={'Course Agreement'} toggle={handleCancel} />
      <ModalBody className='scrollbar justify-content-center text-center'>
        {/* Instruction for user */}
        <p className='mb-4 text-sm text-warning'>
          You must accept this agreement to receive your course certificate.
        </p>

        {/* Agreement content from admin */}
        <div
          className='mb-4 text-start'
          style={{ maxHeight: '400px', overflowY: 'auto' }}
          dangerouslySetInnerHTML={{ __html: agreementContent }}
        />

        {/* Action buttons */}
        <div
          className='d-flex w-100 justify-content-center mt-4'
          style={{ gap: '1rem' }}
        >
          <button className='btn btn-success px-4' onClick={handleAgree}>
            I Agree and Continue
          </button>
          <button className='btn btn-secondary px-4' onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default CompletionTermsModal
